import { PropsWithClassName } from 'lib-shared-types-utils';
import { useEffect, useState } from 'react';

import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';
import { pubSub } from 'utils/pubSub';

import { MimSidekickLauncher } from './components/mimSidekickLauncher/mimSidekickLauncher';
import { MimSidekickWidget } from './components/mimSidekickWidget/mimSidekickWidget';

export const MimSidekick = ({
  className,
}: PropsWithClassName): JSX.Element | null => {
  const { mimSidekick } = useFeatureFlag(['mim-sidekick']);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const unsubscribe = pubSub.subscribe(
      'toggleMimSidekick',
      ({ isOpen: next }) => setIsOpen((prev) => next ?? !prev),
    );
    return unsubscribe;
  }, []);

  if (!mimSidekick) return null;
  if (!isOpen) return <MimSidekickLauncher onClick={() => setIsOpen(true)} />;
  return (
    <MimSidekickWidget
      className={className ?? ''}
      onClose={() => setIsOpen(false)}
    />
  );
};
